/**
 * usePratiche — F-005 Phase 4 (IMPL-P4-003).
 *
 * TanStack Query hook for the active-pratiche list. Polls every 30s
 * (`refetchInterval`) so the list reflects operator-side state changes without
 * a manual refresh. Background polling is disabled to avoid traffic on hidden
 * tabs.
 */
import { useQuery } from '@tanstack/react-query';

import { praticaStatusClient } from '../lib/pratica-status-client';

export function usePratiche(page = 1) {
  return useQuery({
    queryKey: ['pratiche', 'list', page],
    queryFn: () => praticaStatusClient.listAttive(page),
    staleTime: 30_000,
    refetchInterval: 30_000,
    refetchIntervalInBackground: false,
  });
}
